import React from 'react';
import { useFormContext } from 'react-hook-form';
import CleanTextArea from '../../components/TextArea/TextArea';

const TextArea: React.FC<any> = ({ state, name, ...props }) => {
  const { register } = useFormContext<any>();

  return (
    <CleanTextArea
      {...register(name, {
        onBlur: (e) => {
          if (props.onBlur) {
            props.onBlur(e);
          }
        },
      })}
      state={state}
      {...props}
    />
  );
};

export default TextArea;
